import React, { useState } from "react";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";

import { IData } from "features/offers/offers.interface";
import Timer from "../../timer/Timer";
import viewallIcon from "assets/icons/viewall-arrow.png";

import "./EvenCarousel.scss";
import { useAppDispatch } from "store/store";
import { useHistory } from "react-router-dom";
import { clearSearchResult } from "features/search-result/searchresult.slice";
import { activeFilters } from "features/search-property/searchproperty.slice";
import { DirectionCheck } from "utils/classnameSwitch";
import OfferCard from "../../OfferCard/OfferCard";

const EvenCarouselComponent: React.FC<IData> = ({
  offers,
  title,
  hasTimer,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [expiryTimestamp, setExpiryTimestamp] = useState(new Date(offers[0]?.expiry || "").getTime());
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: "0",
    variableWidth: true,
    prevArrow: (
      <div>
        <button
          className="carousel-arrow carousel-arrow-left"
          type="button"
        >
          <img src={viewallIcon} alt="view all"></img>
        </button>
      </div>
    ),
    nextArrow: (
      <div>
        <button
          className="carousel-arrow carousel-arrow-right"
          type="button"
        >
          <img src={viewallIcon} alt="view all"></img>
        </button>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false,
        },
      },
    ],
    afterChange: (index: number) => setExpiryTimestamp(new Date(offers[index]?.expiry || "").getTime())
  };

  const showOfferDetails = (id: any) => {
    const params: any = {};
    params['offer_id'] = id;
    params['page'] = null;
    dispatch(clearSearchResult());
    dispatch(activeFilters(params));
    history.push("/search-results");
  };

  return (
    <>
      <h3 className="layout-grid offer-sections-header" dir={DirectionCheck()}>
        {title} <Timer expiryTimestamp={expiryTimestamp} />
      </h3>
      <div className="carousel-wrapper even-carousel">
        <Slider {...carouselSettings}>
          {
            offers.map((data, key) => {
              return (
                <div className={`offers-wrapper ${offers.length === 1 ? 'w-100vw' : ''}`} key={key}>
                  <div className={`offers-inner-wrapper ${offers.length === 1 ? 'even-carousel-single-data' : ''}`} dir={DirectionCheck()}>
                    <OfferCard 
                      data={data} 
                      variant="even-carousel" 
                      showViewButton={true}
                      onClick={() => showOfferDetails(data.id)}
                    />
                  </div>
                </div>
              );
            })
          }
        </Slider>
      </div>
    </>
  );
};

export default EvenCarouselComponent;
